module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/feature_02-5d237001f2edc56ed5ed4fe1d510b56f.jpg";